/*!

=========================================================
* Purity UI Dashboard PRO - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/purity-ui-dashboard-pro
* Copyright 2021 Creative Tim (https://www.creative-tim.com/)

* Design by Creative Tim & Coded by Simmmple

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

import { mode } from '@chakra-ui/theme-tools';

export const globalStyles = {
	colors: {
		gray: {
			700: '#1f2733'
		},
		teal: {
			500: 'rgb(79, 209, 197)'
		},
		// TG Cam brand ramp, sampled from the lens-iris mark in assets/img/tgcamLogo.png.
		// brand.500 is the navy already used by Sidebar.js; brand.400 is the bright end
		// of the logo gradient; brand.900 is the hero ground.
		brand: {
			50: '#EAF2FB',
			100: '#C9DDF4',
			200: '#9DC3EA',
			300: '#6BA5DE',
			400: '#2B8FD4',
			500: '#19418F',
			600: '#153873',
			700: '#102B58',
			800: '#0C1F3E',
			900: '#0A1020'
		},
		// Reserved for AI detection markers and "new" badges only.
		signal: {
			400: '#FFA24D',
			500: '#FF8A1F',
			600: '#E2740F'
		}
	},
	styles: {
		global: (props) => ({
			body: {
				bg:
					document.documentElement.layout === 'auth'
						? mode('white', 'gray.800')(props)
						: mode('gray.50', 'gray.800')(props),
				fontFamily: "'Roboto', sans-serif"
			},
			html: {
				fontFamily: "'Roboto', sans-serif"
			}
		})
	}
};
